<!--src/core/components/modal/BaseModal.vue-->
<template>
  <transition name="fade">
    <div v-if="visible"
         class="fixed inset-0 flex items-center justify-center"
         :class="overlayClass"
    >
      <div :class="['bg-white dark:bg-gray-800 rounded-lg shadow-lg', modalClass]">
        <header class="flex justify-between items-center p-4 border-b border-gray-300 dark:border-gray-700">
          <div class="flex items-center gap-4">
            <h2 class="text-xl text-gray-800 dark:text-gray-300">{{ title }}</h2>
            <slot name="header-action"></slot>
          </div>
          <div class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 flex gap-2 cursor-pointer" @click="closeModal">
            <span>{{ closeButtonText}}</span>
            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
              <g fill="none" fill-rule="evenodd">
                <path d="M-5-5h24v24H-5z"></path>
                <path class="fill" fill="currentColor" d="M2.05.636 13.364 11.95l-1.414 1.414L.636 2.05z"></path>
                <path class="fill" fill="currentColor" d="M.636 11.95 11.95.636l1.414 1.414L2.05 13.364z"></path>
              </g>
            </svg>
          </div>
        </header>
        <div class="p-4 text-gray-800 dark:text-gray-300">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import {ref, watch} from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  modalClass: {
    type: String,
    default: '',
  },
  closeButtonText: {
    type: String,
    default: '',
    required: false,
  },
  overlayClass: {
    type: String,
    default: 'bg-black bg-opacity-50 z-50',
  },
});

const emit = defineEmits(['update:modelValue']);
const visible = ref(props.modelValue);

watch(() => props.modelValue, (newVal) => {
  visible.value = newVal;
});

const closeModal = () => {
  visible.value = false;
  emit('update:modelValue', false);
};
</script>

<style scoped>
</style>
